import { render, staticRenderFns } from "./ForbiddenView.vue?vue&type=template&id=bd84029e&scoped=true"
import script from "./ForbiddenView.vue?vue&type=script&lang=js"
export * from "./ForbiddenView.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenView.vue?vue&type=style&index=0&id=bd84029e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd84029e",
  null
  
)

export default component.exports